<template>
    <div>
        <div class="edit" data-toggle="modal" :data-target="'#edit-'+this.id" ><span class="material-icons">edit</span></div>
        <div class="modal" tabindex="-1"  :id="'edit-'+this.id" ref="'vuemodal" :key="'edit-'+this.id">
            <div class="modal-dialog modal-xl" role="document" >
                <div class="modal-content">
                    <div class="loader" v-if="loading">
                        <img src="/images/loading.svg" alt="Loading">
                    </div>
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Priekšmeta labošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modalNavigation">
                        <div class="navigationButton prev" @click="openPrevItemModal()">
                            <span class="material-icons">chevron_left</span>
                        </div>
                        <div class="navigationButton next" @click="openNextItemModal()">
                            <span class="material-icons next">chevron_right</span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="modalMenu">
                            <span class="modalMenuItem" @click="changeStep('main')" :class="{'active': step === 'main'}">Pamatinformācija</span>
                            <span class="modalMenuItem" @click="changeStep('scientific')" :class="{'active': step === 'scientific'}">Zinātniskais apraksts</span>
                            <span class="modalMenuItem" @click="changeStep('images')" :class="{'active': step === 'images'}">Attēli un faili</span>
                            <span class="modalMenuItem" @click="changeStep('events')" :class="{'active': step === 'events'}">Priekšmeta vēsture</span>
                            <span class="modalMenuItem" @click="changeStep('other')" :class="{'active': step === 'other'}">Citi lauki</span>
                        </div>
                        <div v-if="step=='main'">
                            <div class="row">
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="cipher">Šifrs</label>
                                        <v-select v-model="cipher" :options="ciphers" :reduce="cipher => cipher.title" label="title"/>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="item_number">Numurs</label>
                                        <input type="number" id="item_number" v-model="item_number" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="item_subnumber">Apakšnumurs</label>
                                        <input type="number" id="item_subnumber" v-model="item_subnumber" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="act_number">Akta numurs <a v-if="act_id" :href="'/act/'+act_id" target="_blank"><span class="material-icons" style="font-size:inherit">open_in_new</span></a></label>
                                        <input type="text" id="act_number" v-model="act_number" class="form-control" disabled>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="acquire_from">Nodevējs</label>
                                        <input type="text" id="acquire_from" v-model="acquire_from" class="form-control">
                                    </div>
                                </div>
<!--                                <div class="col-2">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="photo_number">Foto numurs</label>-->
<!--                                        <input type="text" id="photo_number" v-model="photo_number" class="form-control">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-2">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="item_count">Skaits</label>-->
<!--                                        <input type="text" id="item_count" v-model="item_count" class="form-control">-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="col-1 d-none">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="post_processing">Pēcapstrāde</label>-->
<!--                                        <select name="post_processing" id="post_processing" :value="post_processing" class="form-control">-->
<!--                                            <option value="-1">Jā</option>-->
<!--                                            <option value="0">Nē</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="title">Nosaukums</label>
                                        <v-select taggable
                                                  v-model="title_id"
                                                  :options="item_titles"
                                                  :create-option="title => (
                                                      { created_at:'', id: title, title: title, updated_at:'' })"
                                                  :reduce="title => title.id"
                                                  label="title"
                                                  :key="item.id+'_title'"
                                        />
                                        <small class="text-danger" v-if="title_id && Number.isInteger(title_id) == false">Jūs grasaties pievienot jaunu nosaukumu</small>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="collection">Kolekcija</label>
                                        <v-select
                                            v-model="collection_id"
                                            :options="item_collections"
                                            :reduce="collection => collection.id"
                                            label="title"
                                            :key="item.id+'_collection'"/>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="scientific_theme">Krājuma komplektēšanas tēma</label>
                                        <v-select
                                            v-model="scientific_theme_id"
                                            :options="scientific_themes"
                                            :reduce="theme => theme.id"
                                            label="title"
                                            :key="item.id+'_scientific_theme'"/>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="transfer_type">Ieguve</label>
                                        <v-select
                                            class="is-invalid"
                                            v-model="transfer_type_id"
                                            :options="transfer_types"
                                            :reduce="transfer_type => transfer_type.id"
                                            label="collection_title"
                                            :key="item.id+'_transfer_type'"/>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="author">Autors</label>
                                        <input type="text" id="author" v-model="author" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="item_copyright_id">Autortiesības</label>
                                        <select name="item_copyright_id" id="item_copyright_id" v-model="item_copyright_id" class="form-control">
                                            <option :value="null">Nav norādīts</option>
                                            <option :value="copyright.id" v-for="copyright in copyrights" :key="'copy-'+copyright.id">{{copyright.status}} ({{copyright.reason}})</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="location_of_manufacture">Izgatavošanas vieta</label>
                                        <input type="text" id="location_of_manufacture" v-model="location_of_manufacture" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="time_of_manufacture">Izgatavošanas laiks</label>
                                        <input type="text" id="time_of_manufacture" v-model="time_of_manufacture" class="form-control">
                                    </div>
                                </div>
<!--                                <div class="col-4">-->
<!--                                    <div class="form-group">-->
<!--                                        <label for="content_date">Satura datējums</label>-->
<!--                                        <input type="text" id="content_date" v-model="content_date" class="form-control">-->
<!--                                    </div>-->
<!--                                </div>-->
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="size">Izmērs</label>
                                        <input type="text" id="size" v-model="size" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="material">Materiāls</label>
                                        <input type="text" id="material" v-model="material" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="placement">Novietojums</label>
                                        <input type="text" id="placement" v-model="placement" class="form-control">
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="price_eur">Cena (EUR)</label>
                                        <input type="text" id="price_eur" v-model="price_eur" class="form-control" >
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-group">
                                        <label for="purchase">Iepirkums</label>
                                        <select name="purchase" id="purchase" v-model="purchase" class="form-control">
                                            <option value="-1">Jā</option>
                                            <option value="0">Nē</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="item_heading">Priekšmeta virsraksts jeb nosaukums</label>
                                        <input type="text" id="item_heading" v-model="item_heading" class="form-control" >
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="description">Apraksts</label>
                                        <textarea rows="5" name="description" id="description" class="form-control" v-model="description">{{description}}</textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="notes">Saglabātība</label>
                                        <textarea rows="2" name="notes" id="notes" class="form-control" v-model="notes">{{notes}}</textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="notes">Redaktora atzīme</label>
                                        <small class="small text-muted">(Šo izvēli aizpilda tikai redaktors)</small>
                                        <div class="editorWrapper">
                                            <div class="editorBtn notVerified" :class="{'active':inspection_status == 'notVerified'}" @click="setInspectionStatus('notVerified')">Nav pārbaudīts</div>
                                            <div class="editorBtn partlyVerified" :class="{'active':inspection_status == 'partlyVerified'}" @click="setInspectionStatus('partlyVerified')">Daļēji atbilst</div>
                                            <div class="editorBtn verified" :class="{'active':inspection_status == 'verified'}" @click="setInspectionStatus('verified')">Pilnībā atbilst</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="inspection_comment">Redaktora komentārs</label>
                                        <small class="small text-muted">(Šo izvēli aizpilda tikai redaktors)</small>
                                        <textarea name="inspection_comment" id="inspection_comment" v-model="inspection_comment" class="form-control">{{inspection_comment}}</textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-group">
                                    <label for="created_by">Priekšmeta pievienotājs</label>
                                    <p class="small muted" v-if="created_by">
                                      {{created_by.firstname}} {{created_by.lastname}} {{normalDateTime(created_at)}}
                                    </p>
                                    <p class="small muted" v-else>
                                      Informācija par priekšmeta pievienotāju nav pieejama.
                                    </p>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='scientific'">
                            <div class="scientificDescriptions">
                                <div class="descriptionWrapper" v-for="description in scientific_description" :key="description.id">
                                    <div class="description">
                                        <div class="form-group">
                                            <label for="status">Apraksts</label>
                                            <textarea  rows="5" class="form-control" v-model="description.description">{{description.description}}</textarea>
                                        </div>
                                        <div class="form-group">
                                            <label for="status">Ieraksta autors</label>
                                            <input type="text" v-if="description.author" class="form-control" disabled :value="description.author.firstname+' '+description.author.lastname">
                                            <input type="text" v-else class="form-control" disabled value="Norādīts aprakstā">
                                        </div>
                                    </div>
                                    <div class="meta">
                                        <div class="form-group status">
                                            <label for="status">Status</label>
                                            <select v-model="description.status" class="form-control">
                                                <option value="accepted">Apstiprināts</option>
                                                <option value="pending">Gaida apstiprināšanu</option>
                                            </select>
                                        </div>
                                        <div class="form-group created_at">
                                            <label for="status">Izveidots</label>
                                            <input type="text" :value="normalDateTime(description.created_at)" class="form-control" disabled>
                                        </div>
                                        <div class="form-group updated_at">
                                            <label for="status">Atjaunots</label>
                                            <input type="text" :value="normalDateTime(description.updated_at)" class="form-control" disabled>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-danger" @click="deleteDescription(description.id)">Dzēst</button>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="actions">
                                    <button class="btn btn-primary" @click="createNewDescription()" :key="item.id">Pievienot jaunu</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='images'">
                            <CoolLightBox
                                :items="imageListForLightbox"
                                :index="index"
                                srcName="src"
                                @close="index = null">
                            </CoolLightBox>
                            <div class="subsection">
                                <div class="title">
                                    Attēlu pievienošana
                                </div>
                            </div>
                            <div class="form-group">
                                <dropzone ref="images" @vdropzone-sending="dropzoneImageSending" @vdropzone-success="dropzoneImageSuccess" @vdropzone-error="dropzoneImageError" :useCustomSlot=true :options="{headers:headers,parallelUploads: 1, previewTemplate: template(),url: '/dashboard/api/items/'+this.id+'/api/imageUpload',maxFilesize: 10, acceptedFiles: ' .jpeg,.jpg,.png,.gif ', thumbnailWidth: 20}" id="file">
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">Pievienot attēlus</h3>
                                    </div>
                                </dropzone>
                            </div>

                            <draggable v-model="item_image_sort" class="gallery" v-bind="dragOptions" @start="drag = true" @end="drag = false" >
                                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                    <div v-for="(image, imageIndex) in this.item_image_sort" :key="image.id" class="galleryItem">
                                        <div class="image">
                                            <img @click="index = imageIndex" :src="'/public/image/thumb/'+image.file_name">
                                            <div class="delete" @click="deleteItemImage(image.id)">
                                                <span class="material-icons">close</span>
                                            </div>
                                        </div>
                                        <div class="description">
                                            <label for="description">Piezīmes</label>
                                            <textarea name="description" id="description" rows="2" class="form-control" v-model="image.notes">{{image.notes}}</textarea>
                                        </div>
                                        <div class="print">
                                            <label for="print">Drukāt</label>
                                            <select name="print" id="print" v-model="image.print" class="form-control">
                                                <option value="-1">Jā</option>
                                                <option value="0">nē</option>
                                            </select>
                                        </div>
                                        <div class="visibility">
                                            <label for="public">Publisks</label>
                                            <select name="public" id="public" v-model="image.public" class="form-control">
                                                <option value="0">Jā</option>
                                                <option value="-1">nē</option>
                                            </select>
                                        </div>
                                    </div>
                                </transition-group>
                            </draggable>

                            <div class="subsection">
                                <div class="title">
                                    Saistīto failu (PDF, Word) pievienošana
                                </div>
                            </div>
                            <dropzone ref="files" @vdropzone-success="dropzoneFileSuccess" @vdropzone-error="dropzoneFileError" :useCustomSlot=true :options="{headers:headers, previewTemplate: template(),url: '/dashboard/api/items/'+id+'/api/fileUpload',maxFilesize: 10,  thumbnailWidth: 20}" id="file">
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">Pievienot saistīto dokumentu.</h3>
                                </div>
                            </dropzone>
                            <div  class="filesList">
                                <div class="file" v-for="file in item_files" :key="file.id">
                                    <div class="fileName">{{file.file_name}}</div>
                                    <div class="actions">
                                        <a :href="'/dashboard/api/items/'+item.id+'/fileDownload/'+file.id" class="download"> <span class="material-icons">download</span></a>
                                        <div @click="deleteFile(id,file.id)" class="delete"> <span class="material-icons">close</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="step=='events'">
                            <div class="subsection">
                                <div class="title">
                                    Manuāli pievienotā priekšmeta vēsture
                                </div>
                            </div>
                            <div class="itemEvents">
                                <table class="table">
                                    <thead class="bg-light">
                                        <tr>
                                            <td>Datums no</td>
                                            <td>Datums līdz</td>
                                            <td>Nosaukums</td>
                                            <td>Apraksts</td>
                                            <td>Darbības</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr class="eventWrapper" v-for="event in events_list" :key="event.id">
                                        <td>
                                            <div class="form-group">
                                                <v-date-picker
                                                    :popover="{ visibility: 'click' }"
                                                    mode="single"
                                                    v-model="event.start_date"
                                                    :type="'date'"
                                                    :locale="'LV'"
                                                    color="teal"
                                                    :masks="{
                                                input: ['DD.MM.YYYY']
                                            }"
                                                />
                                            </div>
                                        </td>
                                        <td><div class="form-group">
                                            <v-date-picker
                                                :popover="{ visibility: 'click' }"
                                                mode="single"
                                                v-model="event.end_date"
                                                :type="'date'"
                                                :locale="'LV'"
                                                color="teal"
                                                :masks="{
                                                input: ['DD.MM.YYYY']
                                            }"
                                            />
                                        </div></td>
                                        <td><input type="text" class="form-control" v-model="event.event_name"></td>
                                        <td style="width:400px">
                                            <textarea type="text" class="form-control" v-model="event.event_description">{{event.event_description}}</textarea>
                                        </td>
                                        <td><button class="btn btn-danger" @click="deleteItemEvent(event.id)">Dzēst</button></td>
                                    </tr>
                                    </tbody>
                                </table>
                                <hr>
                                <div class="actions">
                                    <button class="btn btn-primary" @click="createNewItemEvent()" :key="item.id">Pievienot jaunu notikumu</button>
                                </div>
                            </div>
                            <item-events-component :id="item.id" :show_link="true"></item-events-component>
                        </div>
                        <div v-if="step=='other'">
                            <div class="subtitle">Informatīvie lauki</div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="old_description">Vecais apraksts</label>
                                        <textarea disabled rows="5" name="old_description" id="old_description" class="form-control" v-model="old_description">{{old_description}}</textarea>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="price_ls">Cena (LS)</label>
                                        <input disabled type="text" id="price_ls" v-model="price_ls" class="form-control">
                                    </div>
                                </div>

                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="entry_date">Ieraksta datums</label>
                                        <input disabled type="text" id="entry_date" v-model="entry_date" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="entry_time">Ieraksta laiks</label>
                                        <input disabled type="text" id="entry_time" v-model="entry_time" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="date_of_migration_to_nmkk">Migrēts uz NMKK</label>
                                        <input disabled type="text" id="date_of_migration_to_nmkk" v-model="date_of_migration_to_nmkk" class="form-control">
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="form-group">
                                        <label for="act_id">Akta identifikators</label>
                                        <a :href="'/act/'+act_id" target="_blank">Atvērt aktu</a>
                                        <input disabled type="text" id="act_id" v-model="act_id" class="form-control">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="scientific_theme">Krājuma komplektēšanas tēma</label>
                                        <input type="text" id="scientific_theme" v-model="scientific_theme" class="form-control">
                                        <small class="muted">Vecā tēma vārdos</small>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="item_value">Priekšmeta vērtība</label>
                                        <input type="text" id="item_value" v-model="item_value" class="form-control">
                                        <small class="muted">Pēdējā novērtēšanas vērtība</small>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="evaluation_report">Novērtēšanas akts</label>
                                        <input type="text" id="evaluation_report" v-model="evaluation_report" class="form-control">
                                        <small class="muted">Pēdējā novērtēšanas akta numurs un datums</small>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="existence">Esība</label>
                                        <input type="text" id="existence" v-model="existence" class="form-control">
                                        <small class="muted">Pēdējā esības vērtība</small>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="existence">Pārbaudes laiks</label>
                                        <input type="text" id="inspection_timestamp" v-model="inspection_timestamp" class="form-control">
                                        <small class="muted">Pēdējās pārbaudes laiks</small>
                                    </div>
                                </div>
                            </div>
                            <div class="subtitle">Vecie lauki</div>
                        </div>



                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn btn-primary" v-if="loading ==false" @click="save()" key="save">Saglabāt</button>
                        <button class="btn btn-primary" v-if="loading ==true" key="loading"><i class="fas fa-spinner fa-spin"></i></button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.editorWrapper{
    display:flex;
    gap:10px;
    .editorBtn{
        padding:10px 15px;
        border-radius:5px;
        border:2px solid #eee;
        cursor: pointer;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: bold;
        color:#777;
        line-height:1;
        transition: .2s all;
        &.active{
            border-color:$blue;
            color:#333;
        }
        &.verified{

        }
        &.partlyVerified{

        }
        &.notVerified
        {

        }
    }
}
.modalNavigation{
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    position:absolute;
    pointer-events: none;
    .navigationButton
    {
        pointer-events:auto;
        background-color:$blue;
        color:#fff;
        width:50px;
        height: 50px;
        border-radius:100%;
        display:flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0px 1px 20px rgba(255, 255, 255, 0.4);
        &.prev{
            margin-left:-60px;
        }
        &.next{
            margin-left:auto;
            margin-right:-60px;
        }
    }
}
.subsection
{
    width:100%;
    display:flex;
    align-items: center;
    padding-bottom:5px;
    padding-top:10px;
    border-bottom:solid 5px #eee;
    margin-bottom:15px;
    .title{
        font-size:18px;
        font-weight:bold;
    }
    .actions{
        margin-left:auto;
    }
}
.scientificDescriptions{
    .descriptionWrapper{
        margin-bottom:20px;
        padding-bottom:15px;
        border-bottom:solid 5px #eee;
        display:flex;
        align-items: flex-start;
        justify-items: center;
        .description{
            flex-grow:1;
        }
        .meta{
            padding-left:30px;
            width:250px;
        }
    }
}
.edit{
    display:flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.modal-body{
    position:relative;
}
.loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    z-index:10;
    img{
        width:100px;
        height:100px;
    }

}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
.gallery>span{
    display:flex;
    flex-wrap:wrap;
    .galleryItem{
        cursor: move;
        padding: 10px;
        width:100%;
        display:flex;
        img{
            max-width:100%;
            height:auto;
        }
        .image{
            position: relative;
            width:25%;
            max-width:200px;
        }
        .description{
            padding:0 20px;
            width:25%;
        }
        .visibility, .print{
            padding:0 20px;
            width:25%;
        }
        .delete{
            position:absolute;
            top:10px;
            right:10px;
            width:30px;
            height:30px;
            background:rgba(47,47,47,.75);
            cursor: pointer;
            border-radius: 100%;
            display:flex;
            align-items: center;
            justify-content: center;

        }
    }
}

</style>

<script>
import Draggable from "vuedraggable";
import Dropzone from 'vue2-dropzone';

export default{
    components: {
        'draggable':Draggable,
        Dropzone
    },
    props:['item','transfer_types', 'item_titles','item_collections','scientific_themes','ciphers','copyrights'],
    mounted()
    {
        this.id=this.$props.item.id;
        this.cipher=this.$props.item.cipher;
        this.item_number=this.$props.item.item_number;
        this.item_subnumber=this.$props.item.item_subnumber;
        this.photo_number=this.$props.item.photo_number;
        this.transfer_type=this.$props.item.transfer_type;
        this.transfer_type_id=this.$props.item.transfer_type_id;
        this.acquire_from=this.$props.item.acquire_from;
        this.collection_old=this.$props.item.collection_old;
        this.title_old=this.$props.item.title_old;
        this.author=this.$props.item.author;
        this.item_copyright_id=this.$props.item.item_copyright_id;
        this.location_of_manufacture=this.$props.item.location_of_manufacture;
        this.time_of_manufacture=this.$props.item.time_of_manufacture;
        this.content_date=this.$props.item.content_date;
        this.old_description=this.$props.item.old_description;
        this.description=this.$props.item.description;
        this.item_heading=this.$props.item.item_heading;
        this.notes=this.$props.item.notes;
        this.placement=this.$props.item.placement;
        this.size=this.$props.item.size;
        this.material=this.$props.item.material;
        this.price_eur=this.$props.item.price_eur;
        this.price_ls=this.$props.item.price_ls;
        this.item_count=this.$props.item.item_count;
        this.entry_date=this.$props.item.entry_date;
        this.entry_time=this.$props.item.entry_time;
        // this.act_number=this.$props.item.act_number;
        this.act_id=this.$props.item.act_id;
        this.post_processing=this.$props.item.post_processing;
        this.purchase=this.$props.item.purchase;
        this.scientific_theme=this.$props.item.scientific_theme;
        this.date_of_migration_to_nmkk=this.$props.item.date_of_migration_to_nmkk;
        this.item_value=this.$props.item.item_value;
        this.evaluation_report=this.$props.item.evaluation_report;
        this.existence=this.$props.item.existence;
        this.acquire_type_id=this.$props.item.acquire_type_id;
        this.collection_id=this.$props.item.collection_id;
        this.title_id=this.$props.item.title_id;
        this.scientific_theme_id=this.$props.item.scientific_theme_id;
        this.act_number = this.$props.item.act && this.$props.item.act.act_number;

        this.item_images = this.$props.item.images;
        this.item_files = this.$props.item.files;
        this.item_image_sort = this.item_images;
        this.scientific_description = this.$props.item.scientific_description;
        this.item_events = this.$props.item.events;

        this.inspection_status = this.$props.item.inspection_status;
        this.inspection_comment = this.$props.item.inspection_comment;
        this.inspection_timestamp = this.$props.item.inspection_timestamp;
        this.inspector_id = this.$props.item.inspection_id;

        this.inspection_status_changed = false;

        this.created_by = this.$props.item.created_by;
        this.created_at = moment(this.$props.item.created_at, moment.ISO_8601)._d;
        this.updated_at = moment(this.$props.item.updated_at, moment.ISO_8601)._d;

        var that = this;
        // EventBus.$on('image_list_updated', (image_list) =>{
        //     that.item_images = image_list;
        //     that.item_image_sort = that.item_images;
        // })



    },
    data()
    {
        return {
            id:"",
            cipher:"",
            item_number:"",
            item_subnumber:"",
            photo_number:"",
            transfer_type:"",
            transfer_type_id:"",
            acquire_from:"",
            collection_old:"",
            title_old:"",
            author:"",
            location_of_manufacture:"",
            time_of_manufacture:"",
            content_date:"",
            old_description:"",
            description:"",
            item_heading:"",
            notes:"",
            placement:"",
            size:"",
            material:"",
            price_eur:"",
            price_ls:"",
            item_count:"",
            entry_date:"",
            entry_time:"",
            act_number:"",
            act_id:"",
            post_processing:"",
            purchase:"",
            scientific_theme:"",
            date_of_migration_to_nmkk:"",
            item_value:"",
            evaluation_report:"",
            existence:"",
            acquire_type_id:"",
            collection_id:"",
            title_id:"",
            scientific_theme_id:"",
            item_copyright_id:"",

            inspection_status: "",
            inspection_comment: "",
            inspection_timestamp: "",
            inspector_id: "",
            inspection_status_changed:false,

            step:"main",
            loading:false,
            index:null,

            item_images:[],
            item_image_sort:[],

            item_files:[],

            scientific_description:[],
            item_events:[],

            created_by:[],
            created_at:"",
            updated_at:"",


            drag: false,
            headers: {
                "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
            },
        }
    },
    methods: {
        setInspectionStatus(status)
        {
            this.inspection_status_changed = true;
            this.inspection_status = status;

        },
        openNextItemModal()
        {
            EventBus.$emit('open_next_item_edit_modal', this.id);
        },
        openPrevItemModal()
        {
          EventBus.$emit('open_prev_item_edit_modal', this.id);
        },
        deleteItemImage(item_image_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst attēlu?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/item/' + this.id + '/delete-item-image/' + item_image_id, {
                            item_images_sort: that.item_image_sort
                        }).then(response => {
                            if (response.data.status == 'ok') {
                                that.item_images = response.data.image_list;
                                that.item_image_sort = that.item_images;
                                this.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                this.$toast.error(response.data.message);
                            }
                        });
                    }
            });
        },
        createNewItemEvent()
        {
            var that = this;
            axios.post('/item/'+this.id+'/create-event',
                {
                    item_events: that. events_list,
                }).then(response =>{
                that.item_events = response.data.item.events;
            });
        },
        deleteItemEvent(event_id)
        {
            var that = this;
            axios.post('/item/'+this.id+'/delete-event/'+event_id,
                {
                    item_events: that. events_list,
                }).then(response =>{
                that.item_events = response.data.item.events;
            });
        },
        createNewDescription()
        {
            var that = this;
            axios.post('/item/'+this.id+'/create-description',
                {
                    scientific_description: that.scientific_description
                }).then(response =>{
                that.scientific_description = response.data.item.scientific_description;
            });
        },
        deleteDescription(id)
        {
            var that = this;
            axios.post('/item/'+this.id+'/delete-description/'+id,
                {
                    scientific_description: that.scientific_description
                }).then(response =>{
                that.scientific_description = response.data.item.scientific_description;
            });
        },
        deleteFile(itemID,fileID)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst failu?',
                text: "Fails tiks neatgriezeniski dzēsts.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    axios.post('/dashboard/api/items/' + itemID + '/fileDelete/' + fileID)
                        .then(response => {
                            that.$toast.open("Fails dzēsts.");
                            that.item_files = response.data.item.files
                        });
                }
            });
        },
        save()
        {
            var data = {
                id:this.id,
                cipher:this.cipher,
                item_number:this.item_number,
                item_subnumber:this.item_subnumber,
                photo_number:this.photo_number,
                // transfer_type:"",
                acquire_from:this.acquire_from,
                // collection_old:this.collection_old, should be populated by id
                // title_old:"",should be populated by id
                author:this.author,
                location_of_manufacture:this.location_of_manufacture,
                time_of_manufacture:this.time_of_manufacture,
                content_date:this.content_date,
                description:this.description,
                item_heading:this.item_heading,
                notes:this.notes,
                placement:this.placement,
                size:this.size,
                material:this.material,
                price_eur:this.price_eur,
                // price_ls:"",
                item_count:this.item_count,
                // act_number:"",
                act_id:this.act_id,
                post_processing:this.post_processing,
                item_copyright_id:this.item_copyright_id,
                purchase:this.purchase,
                // scientific_theme:"",
                // date_of_migration_to_nmkk:"",

                // price:this.price,
                // evaluation_report:this.evaluation_report,
                // existence:this.existence,

                transfer_type_id:this.transfer_type_id,
                collection_id:this.collection_id,
                title_id:this.title_id,
                scientific_theme_id:this.scientific_theme_id,
                // old_item:"",

                item_image_sort: this.item_image_sort,
                scientific_description: this.scientific_description,
                item_events: this.events_list,

                inspection_status: this.inspection_status,
                inspection_comment: this.inspection_comment,
                inspection_status_changed: this.inspection_status_changed,
            };
            var that = this;
            that.loading = true;
            axios.post('/dashboard/item/'+this.id+'/update',data).then(response =>{
                that.loading = false;
                that.$toast.open(response.data.message);
                EventBus.$emit('items_updated', response.data.act.items);
            }).catch(error => {
                that.loading = false;
                that.$toast.error("Informācija nav saglabāta. Lūdzu pārbaudiet priekšmeta laukus un mēģiniet vēlreiz.");
            });
        },
        changeStep(name){
            this.step = name;
        },
        dropzoneFileSuccess(file, response)
        {
            var that = this;
            that.item_files = response.item.files
            this.$toast.open({
                message:"Fails - "+response.file.file_name+" - veiksmīgi augšupielādēts.",
                type:"success"
            });
            this.$refs.files.removeFile(file);
        },
        dropzoneFileError(file, message, xhr)
        {
            this.$toast.open({
                message:"Faila augšupielāde neizdevās."+message,
                type:"error"
            });
            this.$refs.files.removeFile(file);
        },
        dropzoneImageSending(file, xhr, formData)
        {

            formData.append('sort', JSON.stringify(this.item_image_sort));
        },
        dropzoneImageSuccess(file, response)
        {

            var that = this;
            that.item_images = response.image_list;
            that.item_image_sort = that.item_images;
            this.$toast.open("Attēls - "+response.image.original_file_name+" - veiksmīgi augšupielādēts.");
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
            this.errors = [];

        },
        dropzoneImageError(file, message, xhr)
        {

            this.$toast.open({
                message: "Attēla augšupielāde neizdevās."+message,
                position: "top-right",
                type:"error",
            });
            if(Array.isArray(this.$refs.images))
            {
                this.$refs.images.forEach(dz => {
                    dz.removeFile(file)
                });
            }
            else
            {
                this.$refs.images.removeFile(file);
            }
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview">
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>

                    </div>
                    <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>

                </div>
            `;
        },
        normalDateTime(date)
        {
            return moment(date).format('DD.MM.YYYY. HH:mm')
        },
        normalDate(date)
        {
            return moment(date).format('DD.MM.YYYY.')
        },
    },

    computed: {
        events_list()
        {
            if(this.item_events)
            {
                return this.item_events.map(function(event)
                {
                    return {
                        id: event.id,
                        item_id: event.item_id,
                        start_date: moment(event.start_date, moment.ISO_8601)._d,
                        end_date: moment(event.end_date, moment.ISO_8601)._d,
                        event_name: event.event_name,
                        event_description: event.event_description,
                        event_type: event.event_type,
                        user: event.user,
                    }
                });
            }
            else {
                return null;
            }
        },
        imageListForLightbox()
        {
            if(this.item_image_sort)
            {
                return this.item_image_sort.map(function(image)
                {
                    return {
                        src:'/image/'+image.file_name,
                        //src:'/storage/items/'+image.item_id+'/images/generated/original/'+image.file_name,
                        description:image.original_file_name,
                    }
                });
            }
            else
            {
                return [];
            }

        },
        dragOptions() {
            return {
                animation: 200,
                // group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
    },


}
</script>
